export const Redeem = () => {
    return (
        <>
            <h4>Invitation Redeemed</h4>

            Thank you, your invitation has been successfully redeemed. You may now close this browser tab.
        </>
    )
};